export const state = () => ({
  title: "",
  message: "",

	popUpLoading: false
});

export const mutations = {
	setLoading(state, {name, value, title, message}) {
    state[name || "popUpLoading"] = value || false;
    state['title'] = title || "";
    state['message'] = message || "";
  }
};

export const getters = {
	popUpLoading: ({popUpLoading}) => popUpLoading,
}
